import { CnRadio } from './cn-radio';
import { CnRadioGroup } from './cn-radio-group';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
CnRadio.Group = CnRadioGroup;
export { CnRadio, CnRadioGroup };
